import React, { useEffect, useState } from "react";

const STORAGE_KEY = "noctua_age_verified";
// Age verification must be periodically re-confirmed (French law best practice + UX):
// 30 days = enough for repeat customers, short enough that shared devices re-verify.
const VERIFICATION_TTL_MS = 30 * 24 * 60 * 60 * 1000;
import { LOGO_IMAGE as LOGO_URL } from "../lib/siteImages";

export const AgeVerification = () => {
  const [open, setOpen] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      setOpen(true);
      return;
    }
    // Backwards compat: old value was the literal string "true" with no timestamp.
    // Treat any non-numeric / expired value as "must re-verify".
    const ts = Number(raw);
    if (!ts || Number.isNaN(ts) || Date.now() - ts > VERIFICATION_TTL_MS) {
      setOpen(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setOpen(false);
  };

  const handleDeny = () => {
    setDenied(true);
  };

  if (!open) return null;

  return (
    <div
      data-testid="age-verification-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0a0f1a]/95 backdrop-blur-md p-5"
    >
      <div className="relative w-full max-w-md border border-[#d4af37]/30 bg-[#0a0f1a] p-8 sm:p-10 fade-up">
        <div className="flex justify-center mb-5">
          <img src={LOGO_URL} alt="Noctua Riviera" width="80" height="80" className="h-20 w-auto" data-testid="age-logo-image" />
        </div>
        <div className="text-center">
          <p className="eyebrow mb-3">Noctua Riviera</p>
          <h2 className="font-display text-3xl sm:text-4xl mb-4 leading-none">
            <span className="shimmer-gold">Avez-vous 18 ans ?</span>
          </h2>
          <div className="gold-line w-16 mx-auto mb-5" />
          <p className="text-sm text-gray-400 leading-relaxed mb-8">
            Ce site contient de l'alcool et du tabac. L'accès est strictement réservé aux personnes
            majeures. La consommation d'alcool est dangereuse pour la santé.
          </p>

          {denied ? (
            <div className="border border-red-500/40 p-5 mb-4 text-sm text-red-300" data-testid="age-denied-message">
              Désolé, l'accès au site est réservé aux personnes majeures.
            </div>
          ) : (
            <div className="flex flex-col gap-3">
              <button
                onClick={handleConfirm}
                data-testid="age-verify-yes-btn"
                className="btn-gold w-full"
              >
                J'ai 18 ans ou plus — Entrer
              </button>
              <button
                onClick={handleDeny}
                data-testid="age-verify-no-btn"
                className="btn-ghost text-sm text-gray-400 hover:text-gray-200"
              >
                Je suis mineur
              </button>
            </div>
          )}

          <p className="mt-6 text-[10px] uppercase tracking-[0.2em] text-gray-600">
            Livraison Cannes — Monaco · 24h/24
          </p>
        </div>
      </div>
    </div>
  );
};
